export default {
  title: 'Your cart',
  subtitle: 'Review your selected items before checkout.',
  limitNotice: 'Maximum {limit} items per order',
  limitIndicator: '{count} / {limit} items',
  soldBy: 'Sold by {merchant}',
  qty: 'Qty {qty}',
  decreaseQty: 'Decrease quantity of {name}',
  increaseQty: 'Increase quantity of {name}',
  remove: 'Remove',
  removeAriaLabel: 'Remove {name}',
  continueShopping: 'Continue shopping',
  orderSummary: 'Order Summary',
  subtotal: 'Subtotal',
  total: 'Total',
  proceedToCheckout: 'Proceed to checkout',
  securePayment: 'Secure EUR payment via your wallet',
  empty: {
    heading: 'Your cart is empty.',
    body: 'Browse the catalog and add a few keys — your selection appears here ready for checkout.',
    cta: 'Browse catalog',
  },
};
